import axios, { ENDPOINT } from '../../../utils/httpClient'

export const initPayment = (data) => {
    // Get paylog configuration from localStorage
    // (It's stored there in auth-context.js after login)
    let isPaylogConfigured = false
    const stored = localStorage.getItem('paylog_configured')
    if (stored !== null) {
        try {
            isPaylogConfigured = JSON.parse(stored) === true
        } catch (error) {
            console.error('Error parsing paylog_configured from localStorage:', error)
            isPaylogConfigured = false
        }
    }
    
    // Include paylog configuration status in the request
    const requestData = {
        ...data,
        isPaylogConfigured: isPaylogConfigured,
    }
    
    return axios.post(`${ENDPOINT}/requests`, requestData)
}

export const getFees = () => {
    return axios.get(`${ENDPOINT}/fees`)
}
